module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-r-dg.9b7a032c.svg";